module.exports = __webpack_public_path__ + "img/8-black.7e8aca66.png";